/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Form from "../../shared/forms/Form";
import Field from "../../shared/forms/Field";
import useForm from "../../shared/forms/useForm";
import { Button } from "primereact/button";
import useApiIncidenciasCobros from "../../api/administracion/useApiIncidenciasCobros";
import moment from "moment";
import FormDropDown from "../../shared/forms/FormFields/FormDropDown";
import FormTextArea from "../../shared/forms/FormFields/FormTextArea";
import FormInputNumber from "../../shared/forms/FormFields/FormInputNumber";
import ReadOnlyProvider from '../../shared/forms/ReadOnlyProvider';
import {TabPanel, TabView} from "primereact/tabview";
import ExGrid from "../../shared/Grid/ExGrid";
import ExColumn from "../../shared/Grid/ExColumn";
import {fechaUtc} from "../../shared/Grid/GridCellRenderers";
import FormCalendar from "../../shared/forms/FormFields/FormCalendar";
const IncidenciasCobrosDetalle = ({ movimientoId, onSaved,close, soloLectura }) => {
    const initialValues = {
    
        solicitudDeGastos: {
            fecha: moment().startOf('day')._d
        }
    };
    
    const api = useApiIncidenciasCobros();   
    const [submitted, setSubmitted] = useState(false);
    initialValues.movimientoId = movimientoId;
    useEffect(() => {
        setSubmitted(false);
        load(movimientoId).then();
    }, [movimientoId])

    const {
        values: cobro,
        setValues,
        onChange,
        onValidate,
        isValid
    } = useForm(initialValues);

    const load = async (movimientoId) => {
        const result = await api.obtener(movimientoId);
        console.log(result)
        setValues(result);

    }
    const guardar = async () => {
        await api.actualizar(cobro.id, cobro);
        onSaved();
        if (!isValid) {
            return;
        }       
    }


    return (
           <>
            <TabView>
                <TabPanel header={"Incidencias Cobro"}>
                    <ReadOnlyProvider defaultReadOnly={soloLectura}>
                        <Form columns={1} values={cobro} width={'100%'}
                              onChange={onChange}
                              onValidate={onValidate}
                              submitted={submitted}
                              className={`form-container full-height full-width ${submitted ? 'submitted' : ''}`}>
                           
                                <Field label="Empleado" field={"empleadoId"} disabled={cobro.liquidado} source="empleados" cols={2}
                                   render={FormDropDown} required={true} />
                       
                                 <Field label="Concepto" field={"conceptoNombre"}   disabled={cobro.liquidado} source="descuentos" cols={2}
                                   render={FormDropDown} required={true} />

                                 <Field label="Monto" field={"monto"}  mode="decimal" disabled={cobro.liquidado} minFractionDigits={2} maxFractionDigits={2} cols={1}
                                   render={FormInputNumber} required={true} /> 

                                 <Field label="No. Exhibiciones" field={"numeroExhibiciones"} cols={1} disabled={cobro.liquidado}
                                   render={FormInputNumber} required={true} />
                                 <Field label="Fecha Inicio" field={"fechaInicio"} render={FormCalendar} cols={1} disabled={cobro.liquidado}/>
                                 <Field label="Saldo Actual" field={"saldoActual"}  mode="decimal" disabled={true} minFractionDigits={2} maxFractionDigits={2} cols={1}
                                   render={FormInputNumber} required={true} />
                                <React.Fragment >                                
                                                                
                                <div className="form-footer">
                                    <Button label="Guardar" className="p-button-outlined" type="button"
                                            onClick={() => guardar(false)} />
                                </div>                                    

                                </React.Fragment>
                      
                            <Field label="Nota" field={"nota"} disabled="true" cols={2} rows={7} required={true}
                                   render={FormTextArea} />

                        
                        </Form>
                    </ReadOnlyProvider>
                </TabPanel>
                <TabPanel header={"Historial"}>
                    <ExGrid data={cobro.historial ?? []}>
                        <ExColumn title={'Accion'} field={'accion'}></ExColumn>
                        <ExColumn title={'Usuario'} field={'auditUser'}></ExColumn>
                        <ExColumn title={'Fecha'} field={'fechaUtc'} cellRenderer={fechaUtc}></ExColumn>
                        <ExColumn title={"Comentarios"} field={'comentarios'}></ExColumn>
                    </ExGrid>
                </TabPanel>
            </TabView>
        </>
    );
};

export default IncidenciasCobrosDetalle;
